import { connect } from "react-redux";
import { AppDispatch } from "../../../store/store";
import { Component } from "react";
import { getContactSalesRequest } from "../../../store/slices/ContactSalesSlice";
import ContactSales from "../../../interfaces/response/ContactSales";
import Loader from "../../../components/common/controls/Loader";
import { ContactRequestStatus } from "../../../shared/enums/ContactRequestStatusEnum";
import ContactSalesGrid from "./ContactSalesGrid"

interface State {
  isContactSalesRequestDataLoaded: boolean;
}

interface Props {
  dispatch: AppDispatch;
  dataSource?: ContactSales[];
}

export class ManageContactRequest extends Component<Props, State> {
  state: Readonly<State> = {
    isContactSalesRequestDataLoaded: false
  };

  componentDidMount() {
    this.setState({ isContactSalesRequestDataLoaded: false });
    this.props.dispatch(getContactSalesRequest(ContactRequestStatus.Received)).finally(() => {
      this.setState({ isContactSalesRequestDataLoaded: true });
    });
  }

  render() {
    return(
      <div>
        
        <ContactSalesGrid />
        <Loader isVisible={!this.state.isContactSalesRequestDataLoaded} />
      </div>
    );
  }
}

export default connect()(ManageContactRequest);